export default "__VITE_ASSET__BV91hwdv__"